// extracted by mini-css-extract-plugin
export default {"head":"goBack_head__BLhV7","arrow":"goBack_arrow__cy-2A","back":"goBack_back__zlySg"};